/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-09 18:22:26
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-23 09:44:38
 * @name: 参数验证
 * @Description: 参数验证
 * @FilePath: \project\src\nestVue\common\validator.js
 * @Author: desktop
 */
export const validator = (arr, req = {}) => {
  let code = 1;
  const errCode = 0;
  let msg = '';
  let toast = false;
  try {
    // 1. 首先判断是否必传
    const requireds = arr.filter(x => x.required);
    for (let x of requireds) {
      if (!Object.keys(req).includes(x.key)) {
        throw {
          code: errCode,
          msg: x.required_message,
          toast: x.required_toast,
        };
      }
    }
    // 2. 验证函数验证
    for (let x in req) {
      if (arr.map(y => y.key).includes(x)) {
        let matchRes = arr[arr.findIndex(y => y.key === x)].match(req[x], req);
        if (matchRes !== '') {
          throw {
            code: errCode,
            msg: matchRes,
            toast: arr[arr.findIndex(y => y.key === x)].match_toast,
          };
        }
      }
    }
    return {
      code,
      msg,
      toast,
    };
  } catch (err) {
    return err;
  }
};